import React, {useEffect, useMemo, useState} from "react";
import {useHistory} from "react-router-dom";
import {Auth} from "../../services/firebase/firebase";
import {useUserPersons} from "../../reusable/hooks/useUserPersons";
import ContentWrapper from "../../reusable/layout/ContentWrapper";
import useSPTranslation from "../../reusable/useSPTranslation";
import {Button} from "@mui/material";
import SPLoader from "../../reusable/loader/SPLoader";
import {useCurrentPersonIds} from "../../context/UserContext";

export function OAuthValidatePage() {
    const [selectedPerson, setSelectedPerson] = useState<string>();
    const history = useHistory()
    const { t } = useSPTranslation();

    const currentPids = useCurrentPersonIds();
    const userPersons = useUserPersons("select");
    const filteredPersons = useMemo(() => {
        if (!userPersons) {
            return userPersons;
        }
        const searchParams = new URLSearchParams(window.location.search);
        const federationQuery = searchParams.get('s');
        if (!federationQuery) {
            return userPersons;
        }
        return userPersons.filter((p) => p.federation === federationQuery)
    }, [userPersons])

    useEffect(() => {
        if (currentPids?.length === 1) {
            setSelectedPerson(currentPids[0])
        }
    }, [currentPids]);

    useEffect(() => {
        if (!selectedPerson) {
            return;
        }

        (async () => {
            const idToken = await Auth.currentUser?.getIdToken(true);
            if (!idToken) throw new Error("Not signed in");

            const searchParams = new URLSearchParams(window.location.search)
            const resp = await fetch(
                `https://europe-west3-${process.env.projectId}.cloudfunctions.net/oauth/validate`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${idToken}`,
                    },
                    body: JSON.stringify({
                        request_id: searchParams.get("request_id"),
                        person_id: selectedPerson,
                        state: searchParams.get("state"),
                        challenge: searchParams.get("challenge"),
                    }),
                }
            );

            if (!resp.ok) throw new Error(await resp.text());
            const { finish_url } = await resp.json();

            // IMPORTANT: this must be a full page navigation (not SPA)
            window.location.assign(
                `https://europe-west3-${process.env.projectId}.cloudfunctions.net/oauth` + finish_url
            );
        })().catch((e) => {
            console.error(e);
        });
    }, [history, selectedPerson]);


    return (
        <div className="wrapper">
            <section
                className="select-section-container"
                style={{
                    marginTop: 0,
                }}
            >
                <ContentWrapper>
                    <h3 className="text-center text-thin mt-3 mb-2">
                        {t("admin.select_organization")}
                    </h3>
                    <div
                        className="card w-100"
                        style={{
                            marginTop: "45px",
                        }}
                    >
                        <div
                            className="d-flex flex-column"
                            style={{
                                padding: "1rem 2rem 1rem 2rem",
                                border: "1px solid black",
                            }}
                        >
                            {filteredPersons ? (
                                <>
                                    {filteredPersons?.map((person) => {
                                        return (
                                            <Button
                                                key={person.document_id}
                                                className="text-body text-decoration-none d-flex justify-content-center"
                                                style={{
                                                    margin: "1rem 0 1rem 0",
                                                    letterSpacing: "0.025em",
                                                    padding: "0.8rem",
                                                    textTransform: "uppercase",
                                                    boxShadow:
                                                        "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                                                }}
                                                onClick={() => {
                                                    setSelectedPerson(person.document_id)
                                                }}
                                            >
                                                <div key={person.document_id}>{person.org_name}</div>
                                            </Button>
                                        );
                                    })}
                                </>
                            ) : (
                                <SPLoader/>
                            )}
                        </div>
                    </div>
                </ContentWrapper>
            </section>
        </div>
    )
}
